import { ClassFlag } from "../../dom-tools/ClassFlag";
import { EventListenerType } from "../../dom-tools/EventListeners";
import { EventSlot } from "../../events/EventSlot";
import { Property } from "../../events/Property";
import { EventListenerCache, EventListenerClass } from "../basics/EventListenerCache";
import { UIProperty } from "../basics/UIProperty";
import { UIComponent } from "../components/UIComponent";
import { GraphicalElement } from "./GraphicalElement";

export class LinkedGraphicalElement<T extends GraphicalElement> extends UIProperty<T>
{
  protected _parent:UIComponent;
  get parent(){ return this._parent; }

  protected _events = new EventListenerCache();
  protected _callbacks:(( t:T, events:EventListenerCache )=>void)[] = [];
  protected _flags:ClassFlag[] = [];



  constructor( parent:UIComponent, ...flags:ClassFlag[] )
  {
    super( parent, null );
    this._parent = parent;
    this._parent._addLinkedGraphicalElement( this );
    this._flags = flags;
    this.#addChangeListener();
  }

  #addChangeListener()
  {
    this.addListener(
      ( ce )=>
      {
        if ( ce.newValue === ce.lastValue )
        {
          return;
        }

        if ( ce.lastValue )
        {
          this._parent._removeElementOfLinked( this, ce.lastValue.element );
          this._events.remove();
        }

        if ( ce.newValue )
        {
          this._parent._addElementOfLinked( this, ce.newValue.element );
          
          this._flags.forEach( f => f.set( ce.newValue.element ) );

          this._callbacks.forEach( cb => cb( ce.newValue, this._events ) );        

          this._parent.redraw();
        }
      }
    )
  }

  addCallback( cb:(t:T, events:EventListenerCache )=>void )
  {
    this._callbacks.push( cb );  
  } 

  onSlot<U>( getTarget:(t:T )=>EventSlot<U>, callback:(u?:U)=>void )
  {
    this.addCallback(
      ( t, events )=>
      {
        let target = getTarget( t );
        events.onSlot( target, callback );
      }
    );
  }

  on<E>( type:EventListenerClass<E>, callback:(e:E)=>void )
  {
    this.addCallback(
      ( t, events )=>
      {
        events.onListener( type, t.element, callback );
      }
    );
  }




}